import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'


export default function Unauthorized() {
  return (
    <Container className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <Row>
          <Col className="text-center">
              <h2 style={{ "color" : "#000000" }}>401</h2> 
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <h5>You are not authorized for selected action</h5>
          </Col>
        </Row>
    </Container>
  )
}
